module.exports = __webpack_public_path__ + "static/media/dept-kvd.85c600c0.jpg";